/** 選手の軌跡（直近 60 分・ゲーム内。docs/05_rendering-and-audio.md 8 章）。描画側で位置を記録する */
import * as THREE from 'three';
import type { AthleteState } from '../../sim/types';

const SAMPLE_S = 30;
const MAX_POINTS = 120;

interface Trail {
  pts: number[];
  line: THREE.Line;
  color: THREE.Color;
}

export class Trails {
  readonly group = new THREE.Group();
  private readonly trails = new Map<string, Trail>();
  private lastSampleS = -Infinity;
  private readonly material = new THREE.LineBasicMaterial({
    vertexColors: true,
    transparent: true,
    depthWrite: false,
  });

  constructor(athletes: AthleteState[]) {
    for (const a of athletes) {
      const line = new THREE.Line(new THREE.BufferGeometry(), this.material);
      line.frustumCulled = false;
      line.renderOrder = 8;
      this.group.add(line);
      this.trails.set(a.id, { pts: [], line, color: new THREE.Color(a.color) });
    }
  }

  update(athletes: AthleteState[], raceTimeS: number): void {
    if (raceTimeS - this.lastSampleS < SAMPLE_S) return;
    this.lastSampleS = raceTimeS;
    for (const a of athletes) {
      const tr = this.trails.get(a.id);
      if (!tr) continue;
      tr.pts.push(a.pos.x, a.pos.y + (a.mode === 'flying' ? 0 : 20), a.pos.z);
      if (tr.pts.length > MAX_POINTS * 3) tr.pts.splice(0, tr.pts.length - MAX_POINTS * 3);
      const n = tr.pts.length / 3;
      const colors = new Float32Array(n * 4);
      for (let i = 0; i < n; i++) {
        colors.set([tr.color.r, tr.color.g, tr.color.b, 0.15 + 0.85 * (i / Math.max(n - 1, 1))], i * 4);
      }
      const geo = new THREE.BufferGeometry();
      geo.setAttribute('position', new THREE.BufferAttribute(new Float32Array(tr.pts), 3));
      geo.setAttribute('color', new THREE.BufferAttribute(colors, 4));
      tr.line.geometry.dispose();
      tr.line.geometry = geo;
    }
  }
}
